import { initialNewAddressData, initialPaymentDetails, } from "./UpdateOrderDeliveryPickupModalContext";
import { TabValues } from "./const-enums-types";
import { deliveryAddressSortingFunction, pickupAddressSortingFunction } from "../../../Addresses/addressesUtils";
/**
 * This function uses the inherent MUI logic.
 * @param setTabValue
 * @param shouldDisplayPaymentForm
 * @param setShouldDisplayPaymentForm
 * @returns
 */
export const handleTabChange = (setTabValue, shouldDisplayPaymentForm, setShouldDisplayPaymentForm) => (_, newValue) => {
    // Unmount PaymentForm when a tab is selected
    if (!!shouldDisplayPaymentForm && newValue !== undefined) {
        setShouldDisplayPaymentForm(false);
    }
    setTabValue(newValue);
};
/**
 * This function bypasses the MUI logic and explicitly sets the tab value.
 * @param setTabValue
 * @returns
 */
export const curriedSetTabValue = (setTabValue) => () => setTabValue(TabValues.ADD_NEW_ADDRESS);
export const onModalClose = (setNewAddressData, setBalance, setShowModal, setPaymentDetails) => () => {
    setNewAddressData(initialNewAddressData);
    // Clear the payment half too: before these were split it was one object, so
    // one reset cleared both. See PaymentDetailsType doc — MT-7300.
    setPaymentDetails(initialPaymentDetails);
    setBalance(undefined);
    setShowModal(false);
};
export const getAddressesToMap = (addresses, pickupLocations, initTabProps) => {
    if (!!addresses)
        return deliveryAddressSortingFunction(initTabProps.initDeliveryLocation, addresses);
    if (!!pickupLocations)
        return pickupAddressSortingFunction(initTabProps.initPickupLocation, pickupLocations);
    return [];
};
